import { render, staticRenderFns } from "./AddNewUserDialogHeader.vue?vue&type=template&id=57c2d1c8&scoped=true"
import script from "./AddNewUserDialogHeader.vue?vue&type=script&lang=js"
export * from "./AddNewUserDialogHeader.vue?vue&type=script&lang=js"
import style0 from "./AddNewUserDialogHeader.vue?vue&type=style&index=0&id=57c2d1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2d1c8",
  null
  
)

export default component.exports